import React from 'react'
import Profile from './Container'
import ResourceLoader from '../../components/ResourceLoader'

const Wrapper = props =>
  <ResourceLoader reducers={ ['profile'] } epics={ ['profile'] }>
    <Profile { ...props } />
  </ResourceLoader>

export default Wrapper
